<template>
     <div class = "Verify-wrapper">
        <el-container>
        <el-header class="Verify_header">
            <p>访客预约</p>
        </el-header>
        <el-main>
            <div id = "Verify">
              <span class="spandiv">
              <div class="sdyulogo">
                <img fit="contain" src="../assets/img/sdyu_logo.png"/>
              </div>
              </span>
              <span class="spandiv">
              <button class="buttenStyle" @click="jumpSMJXLC">校内人员申请</button>
              </span>
              <span class="spandiv">
              <button  class="buttenStyle" @click="clickVerify">校外人员申请</button>
              </span>
              <span class="spandiv">
              <button  class="buttenStyle" @click="clickVerify1">点击查看门禁二维码</button>
              </span>
            </div>
        </el-main>
        
        <div class="Verify_footer">
          Copyright@山东青年政治学院
        </div>
        
    </el-container>


    </div>
</template>
<script>
export default {
  data(){
    return {
      imgurl: './src/assets/img/sdyu_logo.png',
      fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
      url: 'src\assets\img\sdyu_logo.png'
    }
  },
    methods: {
        clickVerify(){
            this.$router.push({path: "/login"});
        },
        clickVerify1(){
        this.$router.push({path: "/login1"});
        },
        jumpSMJXLC(){
          console.log(123);
          window.open('http://i.sdyu.edu.cn/infoplus/form/SMJXLC/start');
        }
    }
}
</script>

<style scoped>
.Verify-wrapper {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}
#Verify {
    max-width: 340px;
    margin: 60px auto;
    background: #fff;
    padding: 20px 40px;
    border-radius: 10px;
    position: relative;
    z-index: 9;
}
#Verify span{
  display: block;
  padding: 10px;
}
.el-form-item {
  text-align: center;
}

.code >>> .el-form-item__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.code button {
  margin-left: 20px;
  width: 140px;
  text-align: center;
}
.Verify_header{
    background-color: #006934;
    text-align: center;
    color: #ffffff;
    font-size: 120%;
}
.inputwidth {
  width: 100%;
}
.sdyulogo{
  width: 100%;
}
.sdyulogo img{
    width: 100%;
  }

.Verify_footer{
  background-color: #006934;
  color: #ffffff;
  text-align: center;
  font-size: 75%;
  position:fixed;
  bottom:0;
  width: 100%;
  height: 20px;
  margin: 0px;
}
.buttenStyle{
  color: #006934;
  background-color: #E7F0EB;
  border: 1px solid #006934;
  border-radius: 4px;
  height: 40px;
  width: 100%;
  padding: 10px;
}

.buttenStyle:focus {
  background: #006934;
  border: 1px solid #006934;
  color: #ffffff; 
}
.buttenStyle:hover{
  background: #006934;
  border: 1px solid #006934;
  color: #ffffff; 
}
.visitor_header {
    background-color: #006934;
    /* opacity: 0.5; */
    text-align: center;
    color: #ffffff;
    font-size: 120%;
  }
</style>